<template>
    <div class="M0002-perm-open-view">
        <!-- <permOpenView ref="M0002-perm-open-ref" :busiData="busiData" :historyData="historyData" :oppBusiData="oppBusiData"></permOpenView> -->
    </div>
</template>

<script>
// import permOpenView from "../commonModules/open-account/common/permOpenView.vue";
export default {
  components: {
    // permOpenView
  },
  props: ["busiData", "historyData", "oppBusiData"],
  data () {
    return {

    };
  },
  mounted () {
    let that = this;
    that.$nextTick(() => { 
      that.$refs["M0002-perm-open-ref"].show(); 
    });
  },
  computed: {},
  methods: {

    validate (_this) {
      var that = _this.$refs["M0002_perm_open_view"];
    },
    beforeSave (_this, params, baseData) {
      var that = _this.$refs["M0002_perm_open_view"];

      let permObj = that.$refs["M0002-perm-open-ref"].getData();

      Object.assign(params, permObj);
    }
  }
};
</script>

<style lang="less" scoped>
.M0002-perm-open-view {
  width: 14.9rem;

}
</style>



// WEBPACK FOOTER //
// src/business/businessFile/QS420/QS420_perm_open_view.vue